import { MembershipConstantS } from '@services/MarppleShop/features/Membership/outbound/share';
import { MembershipAdjustmentServiceType } from '@services/MarppleShop/features/Membership/type';
import { html } from 'fxjs/es';
import { makeQueryString } from '../../../../shared/utils/makeString/makeQueryString';
import {
  isStoreProductCustomLevelAsset,
  isStoreProductCustomLevelUser,
} from '../../../Creator/Product/S/fs.js';
import { messages } from '../../../Creator/Setting/S/messages_id.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { GoodsTypeConstantS } from '../Constant/module/GoodsTypeConstantS.js';
import { GoodsTypeS } from '../Function/module/GoodsTypeS.js';

export const selectGoodsTypeHref = ({
  has_permission_tpl,
  goods_type_id,
  href,
  query,
}: {
  has_permission_tpl: boolean;
  goods_type_id: string;
  href: string;
  query: {
    paid_at_from?: string;
    paid_at_to?: string;
    selected_preset?: string;
  };
}) => {
  if (has_permission_tpl) {
    const query_param = query
      ? `?${makeQueryString({
          ...(query.paid_at_from ? { paid_at_from: query.paid_at_from } : {}),
          ...(query.paid_at_to ? { paid_at_to: query.paid_at_to } : {}),
          ...(query.selected_preset ? { selected_preset: query.selected_preset } : {}),
        })}`
      : '';

    return html`
      <div class="select-goods-type-href">
        <div class="select-goods-type-href__items">
          <div
            data-goods_type_id="${GoodsTypeConstantS.PBG.id}"
            class="select-goods-type-href__item${GoodsTypeS.isPbg(goods_type_id)
              ? ' select-goods-type-href__item--selected'
              : ''}"
          >
            <a href="${href}${query_param}">크리에이터 배송 상품</a>
          </div>
          <div
            data-goods_type_id="${GoodsTypeConstantS.TPL.id}"
            class="select-goods-type-href__item${GoodsTypeS.isTpl(goods_type_id)
              ? ' select-goods-type-href__item--selected'
              : ''}"
          >
            <a href="${href}/tpl${query_param}">${UtilS.isNessApp() ? '넥슨에센셜' : '마플샵'} 배송 상품</a>
          </div>
        </div>
      </div>
    `;
  }
};

export const adjustmentGoodsTypeHref = ({
  has_permission_tpl,
  goods_type_id,
  domain_name,
  menu_name,
  custom_level,
  is_membership_available,
}: {
  has_permission_tpl: boolean;
  goods_type_id?: string;
  domain_name: string;
  menu_name?: MembershipAdjustmentServiceType;
  custom_level?: string;
  is_membership_available: boolean;
}) => {
  const is_mps = UtilS.isMarppleShopApp();

  return html` <div class="select-goods-type-href">
    <div class="select-goods-type-href__items">
      <div
        data-goods_type_id="${GoodsTypeConstantS.MPS.id}"
        class="select-goods-type-href__item${GoodsTypeS.isMps(goods_type_id) && !custom_level
          ? ' select-goods-type-href__item--selected'
          : ''}"
      >
        <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/adjustments"
          >${is_mps
            ? ET('mps2::seller_studio::adjustment::marppleshop_product')
            : UtilS.isNessApp()
              ? T(messages.menus.design_adjustments_ness)
              : T(messages.menus.design_adjustments)}</a
        >
      </div>
      <div
        data-goods_type_id="${GoodsTypeConstantS.PBG.id}"
        class="select-goods-type-href__item${GoodsTypeS.isPbg(goods_type_id)
          ? ' select-goods-type-href__item--selected'
          : ''}"
      >
        <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/pb_adjustments"
          >${is_mps
            ? ET('mps2::seller_studio::adjustment::creator_product')
            : T(messages.menus.seller_adjustments)}</a
        >
      </div>
      ${has_permission_tpl
        ? html` <div
            data-goods_type_id="${GoodsTypeConstantS.TPL.id}"
            class="select-goods-type-href__item${GoodsTypeS.isTpl(goods_type_id)
              ? ' select-goods-type-href__item--selected'
              : ''}"
          >
            <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/tpl_adjustments"
              >${is_mps
                ? ET('mps2::seller_studio::adjustment::tpl_product')
                : UtilS.isNessApp()
                  ? T(messages.menus.tpl_adjustments_ness)
                  : T(messages.menus.tpl_adjustments)}</a
            >
          </div>`
        : ''}
      <div
        data-goods_type_id="${GoodsTypeConstantS.DTG.id}"
        class="select-goods-type-href__item${GoodsTypeS.isDtg(goods_type_id)
          ? ' select-goods-type-href__item--selected'
          : ''}"
      >
        <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/dtg_adjustments"
          >${is_mps
            ? ET('mps2::seller_studio::adjustment::digital_product')
            : T(messages.menus.dtg_adjustments)}</a
        >
      </div>
      ${
        // 멤버십 - ness 에서는 안씀
        !is_membership_available
          ? ``
          : html` <div
                class="select-goods-type-href__item ${menu_name == MembershipConstantS.MEMBERSHIP
                  ? 'select-goods-type-href__item--selected'
                  : ''}"
              >
                <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/membership_adjustments"
                  >${T(messages.menus.membership_adjustment)}</a
                >
              </div>
              <div
                class="select-goods-type-href__item ${menu_name == MembershipConstantS.COMMISSION
                  ? 'select-goods-type-href__item--selected'
                  : ''}"
              >
                <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/commission_adjustments"
                  >${T(messages.menus.commission_adjustment)}</a
                >
              </div>
              <div
                class="select-goods-type-href__item ${menu_name == MembershipConstantS.SUPPORT
                  ? 'select-goods-type-href__item--selected'
                  : ''}"
              >
                <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/support_adjustments"
                  >${T(messages.menus.support_adjustment)}</a
                >
              </div>`
      }
      ${
        // 크리에이터 디자인 - TODO: 제약 조건에 대해 확인 필요
        html`
          <div
            class="select-goods-type-href__item ${goods_type_id === 'MCON'
              ? 'select-goods-type-href__item--selected'
              : ''}"
          >
            <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/mcon_adjustments"
              >${T(messages.menus.mcon_adjustment)}</a
            >
          </div>
        `
      }
      ${UtilS.isNessApp()
        ? html` <div
              data-goods_type_id="${GoodsTypeConstantS.MPS.id}"
              class="select-goods-type-href__item${GoodsTypeS.isMps(goods_type_id) &&
              isStoreProductCustomLevelAsset(custom_level)
                ? ' select-goods-type-href__item--selected'
                : ''}"
            >
              <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/ness_asset_adjustments"
                >${T('studio::menus::asset_adjustment')}</a
              >
            </div>
            <div
              data-goods_type_id="${GoodsTypeConstantS.MPS.id}"
              class="select-goods-type-href__item${GoodsTypeS.isMps(goods_type_id) &&
              isStoreProductCustomLevelUser(custom_level)
                ? ' select-goods-type-href__item--selected'
                : ''}"
            >
              <a href="/${T.lang}/${UtilS.escape(domain_name)}/settings/ness_user_adjustments"
                >${T('studio::menus::user_adjustment')}</a
              >
            </div>`
        : ''}
    </div>
  </div>`;
};
